import { defaultChartColors } from "views/components/visualizations/Colors";
import { GROUPINGS, groupByKey, groupOf, sum, toBreakdownRows } from "ai-management/token-usage/breakdown";
export const assignColors = (colors, keys) => {
  const newKeys = keys.filter((key) => !colors.has(key)).sort();
  if (newKeys.length === 0) {
    return colors;
  }
  return new Map([
    ...colors,
    ...newKeys.map((key, index) => [key, defaultChartColors[(colors.size + index) % defaultChartColors.length]])
  ]);
};
export const groupingKeys = (rows, grouping) => [
  ...groupByKey(rows, GROUPINGS[grouping].columns).keys()
];
export const toTimeSeries = (rows, grouping) => {
  const { columns } = GROUPINGS[grouping];
  const buckets = [...new Set(rows.map(({ bucket }) => bucket).filter((bucket) => !!bucket))].sort();
  const totalTokens = (row) => row.tokens.total_tokens;
  const series = [...groupByKey(rows, columns)].map(([key, seriesRows]) => ({
    key,
    group: groupOf(seriesRows[0].group, columns),
    values: buckets.map((bucket) => sum(seriesRows.filter((row) => row.bucket === bucket), totalTokens)),
    total: sum(seriesRows, totalTokens)
  }));
  return { buckets, series: series.sort((a, b) => b.total - a.total) };
};
export const toSlices = (rows, grouping) => toBreakdownRows(rows, grouping).filter(({ totalTokens }) => totalTokens > 0).map(({ key, group, totalTokens }) => ({ key, group, totalTokens }));
